<template>
  <div class="ms-container">
    <div class="filters-bar">
      <module-header style="margin-bottom: 0">Судебные дела</module-header>
      <div class="filters-bar-right">
        <law-cases-filter />
        <div class="resources-export-button">
          <i-button
            class="export-table-button"
            @click="exportTable"
            type="primary"
            icon="ios-grid"
          >
            Экспорт таблицы
          </i-button>
          <i-button
            @click="exportData"
            type="primary"
            icon="md-cloud-download"
          >
            Скачать документы
          </i-button>
        </div>
      </div>
    </div>
    <div class="law-cases">
      <inline-loader :loading="loading" v-if="loading && !nodata" />
      <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
        Не удалось загрузить список судебных дел. Повторите, пожалуйста, попытку
        позже
      </div>
      <law-cases-list
        :law-cases="lawCases"
        v-else-if="lawCases.length"
        @open-law-case="openLawCase"
        :all="true"
      />
      <div v-else class="ms-nodata ms-text">
        Судебные дела отсутствуют
      </div>
    </div>
  </div>
</template>

<script>
import ModuleHeader from '@/components/parts/module-header'
import LawCasesList from '@/components/law-cases/law-cases-list'
import InlineLoader from '@/components/loaders/inline-loader'
import LawCasesFilter from '@/components/filters/law-cases'
import { downloadFile } from '@/utils'
import { mainUrl } from '@/config/urls'
import { getLawCasesUrl } from '@/config/filters'

export default {
  components: {
    ModuleHeader,
    InlineLoader,
    LawCasesList,
    LawCasesFilter
  },
  data () {
    return {
      loading: false,
      nodata: false,
      lawCases: [],
      token: this.$store.state.auth.token
    }
  },
  watch: {
    '$store.state.filters.lawCases': {
      handler: function () {
        this.getData(true)
      },
      deep: true
    }
  },
  methods: {
    async getData () {
      try {
        this.loading = true
        const url = getLawCasesUrl('page/law_case?', this.$store.state.filters.lawCases)
        this.lawCases = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.nodata = true
      }
    },
    openLawCase ({ id, contract_id }) {
      this.$router.push(`/app/contracts/${contract_id}/law-cases?open=${id}`)
    },
    exportData () {
      const baseUrl = `page/all_document?contract_id=all&as_file=true&object_type=law_cases`
      const url = `${mainUrl}/api/${baseUrl}&access_token=${this.token}`

      downloadFile(url)
    },
    exportTable () {
      const baseUrl = getLawCasesUrl('page/law_case?', this.$store.state.filters.lawCases)
      const url = `${mainUrl}/api/${baseUrl}&format=excel&access_token=${this.token}`

      downloadFile(url)
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style>

</style>
